import { apiClient } from "@/shared/services/api";
import type { ApiResponse } from "@/features/auth/services/authApi";

export interface CustomerDeliveryAddress {
  id: string;
  customerId: string;
  label: string;
  transportRateId: string;
  pricingRegion: string;
  deliveryAreaId: string;
  deliveryArea: string;
  address: string;
  latitude?: number | null;
  longitude?: number | null;
  rowVersion: number;
}

export interface CustomerDeliveryAddressList {
  items: CustomerDeliveryAddress[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

export const customerDeliveryAddressesApi = {
  list: async (customerId: string, pageNumber = 1) => {
    const result = await apiClient.get<ApiResponse<CustomerDeliveryAddressList>>(
      `/customers/${customerId}/delivery-addresses`, { params: { pageNumber, pageSize: 100 } });
    return result.data.data;
  },
  create: async (customerId: string, request: {
    label: string; deliveryAreaId: string; address: string;
    latitude?: number | null; longitude?: number | null;
  }) => {
    const result = await apiClient.post<ApiResponse<CustomerDeliveryAddress>>(
      `/customers/${customerId}/delivery-addresses`, request);
    return result.data.data;
  },
};
